/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import Logo_Linkcampus from "../image/Logo_Linkcampus.png";

import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";

import ic_드라이브형 from "../image/ic_드라이브형.png";
import ic_드라이브형_sel from "../image/ic_드라이브형_sel.png";
import ic_주차시설관리 from "../image/ic_주차시설관리.png";
import ic_주차시설관리_sel from "../image/ic_주차시설관리_sel.png";
import ic_표준형 from "../image/ic_표준형.png";
import ic_표준형_sel from "../image/ic_표준형_sel.png";

import Platform_FMS_드라이브형 from "../1.APPWEB/Platform_FMS_드라이브형";
import Platform_FMS_주차시설 from "../1.APPWEB/Platform_FMS_주차시설";
import Platform_FMS_표준형 from "../1.APPWEB/Platform_FMS_표준형";
import Footer_FMS from "./Footer_FMS";
import Side_FMS from "./Side_FMS";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 85px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  padding: 10px;
  @media (max-width: 800px) {
    padding: 0px;
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: #c0c0c0;
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
  }
`;

const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 30px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding-top: 0px;
  }
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const UnderLine = styled.div`
  position: absolute;
  bottom: 0px;
  width: 50px;
  height: 2px;
  background-color: black;
  @media (max-width: 800px) {
    width: 31px;
    height: 1px;
  }
`;

const Platform_Select_div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  @media (max-width: 800px) {
    margin-top: 0px;
    margin-bottom: 30px;
  }
`;

const Platform_Select_Image = styled(Image)`
  width: 200px;
  cursor: pointer;
  margin: 5px;
  @media (max-width: 800px) {
    width: 120px;
  }
`;

function Platform_FMS() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const [select_platform, set_Select_Platform] = useState("표준형");
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const go_Home = () => {
    navigation("/");
  };
  const go_About = () => {
    navigation("/about");
  };
  const go_Info = () => {
    navigation("/Info");
  };
  const go_Platform = () => {
    navigation("/Platform");
  };
  const go_Process = () => {
    navigation("/Process_FMS");
    window.scrollTo({ top: 0 });
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_div>
          <Logo_img
            onClick={() => {
              go_Home();
            }}
            src={Logo_Linkcampus}
            alt={Logo_Linkcampus}
          />
          <Top_Button
            onClick={() => {
              go_Info();
              window.scrollTo({ top: 0 });
            }}
          >
            회사소개
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Process();
            }}
          >
            프로세스
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Platform();
            }}
            style={{ color: "black" }}
          >
            플랫폼
            <UnderLine />
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_About();
              window.scrollTo({ top: 0 });
            }}
          >
            제작문의
          </Top_Button>
        </Header_div>
      </Header>
      <Main>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                플랫폼
              </Content_Text>
              <Footer_Text>
                링크캠퍼스가 제공하는 FMS 기본 플랫폼입니다.
              </Footer_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div style={{ flexDirection: "column" }}>
          <Platform_Select_div>
            <Platform_Select_Image
              onClick={() => {
                set_Select_Platform("표준형");
              }}
              src={select_platform === "표준형" ? ic_표준형_sel : ic_표준형}
              alt={ic_표준형}
            />
            <Platform_Select_Image
              onClick={() => {
                set_Select_Platform("드라이브형");
              }}
              src={
                select_platform === "드라이브형"
                  ? ic_드라이브형_sel
                  : ic_드라이브형
              }
              alt={ic_드라이브형}
            />
            <Platform_Select_Image
              onClick={() => {
                set_Select_Platform("주차시설 관리");
              }}
              src={
                select_platform === "주차시설 관리"
                  ? ic_주차시설관리_sel
                  : ic_주차시설관리
              }
              alt={ic_주차시설관리}
            />
          </Platform_Select_div>
          {select_platform === "표준형" ? (
            <Platform_FMS_표준형 />
          ) : select_platform === "드라이브형" ? (
            <Platform_FMS_드라이브형 />
          ) : (
            <Platform_FMS_주차시설 />
          )}
        </Main_div>

        <Side_FMS width={windowSize.width} />
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Platform_FMS;
